export default {"src":"/_next/static/media/search.91a2e367.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};